import React from 'react'
import injectSheet from 'react-jss'
import { TopStep } from '../../'

const AdminTopStepper = (props) => {
  const {
    classes,
    classNames,
    currentPath,
    history,
    steps,
  } = props

  return (
    <div className={`${classNames} ${classes.container}`} >
      <ul className={classes.stepperList} >
        {steps && steps.length && steps.map(step => (
          <TopStep
            active={currentPath === step.path}
            activated={step.activated}
            index={step.id - 1}
            history={history}
            key={`adminTopStep-${step.id}`}
            path={`/admin/${step.path}`}
            title={step.title}
            noConnect
          />
        ))}
      </ul>
    </div>
  )
}

const styles = theme => ({
  container: {
    backgroundColor: theme.colors.main,
    zIndex: 1,
  },
  stepperList: {
    listStyleType: 'none',
    margin: 0,
    padding: `0 ${theme.sizes.gutter / 2}px ${theme.sizes.gutter}px ${theme.sizes.gutter / 2}px`,
    display: 'flex',
    justifyContent: 'center',
  },
})

export default injectSheet(styles)(AdminTopStepper)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminTopStepper.jsx